import React, { useEffect, useRef, useState } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { FormatAmount } from "app/utils/utility.service";


ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip
);



const LineChartIncome = ({ chartData, lifeEvents, years }) => {

  const chartRef = useRef();
  //const years = generateYears();
  const [mode, setMode] = useState("ACCOUNT");
  const [activeAccount, setActiveAccount] = useState(null);
  const [activeAccountCat, setActiveAccountCat] = useState(null);
  const getYear = (date) => new Date(date).getFullYear();
  //const [scatterData, setScatterData] = useState([]);
  let datasets;
 
  const labels = chartData.map((r) => r.year);
  /*const dataPoints = lifeEvents.map((event) => event.plannedExpense);*/
  const normalizedReportData = chartData.map((r) => {
    const opening = Number(r.openingBalance || 0);

    // if growth is % (like 4.5), convert to value
    const growthValue =
      r.growth <= 1 || r.growth < 100
        ? opening * (Number(r.growth) / 100)
        : Number(r.growth);

    return {
      ...r,
      openingBalance: Number(r.openingBalance || 0),
      income: Number(r.income || 0),
      plannedExpenses: Number(r.plannedExpenses || 0),
      depletion: Math.abs(Number(r.depletion || 0)),
      growth: Number(growthValue.toFixed(2)),
      closingBalance: Number(r.closingBalance || 0),
    };
  });

  const lifeEventsDataset = {
    label: "Life Events",
    type: "scatter",
    data: (lifeEvents || [])
      .map((event) => {
        const year = getYear(event.plannedDate);

        // Only plot if year exists in labels
        const index = labels.indexOf(year);
        if (index === -1) return null;
        return {
          x: year,
          y: Number(event.plannedExpense) || 0,
          name: event.eventname,
          plannedExpense: Number(event.plannedExpense),
          endYear: getYear(
            event.completionDate ? event.completionDate : new Date()
          ),
        };
      })
      .filter(Boolean),

    pointRadius: 8,

    pointBackgroundColor: "green",
    pointBorderColor: "green",
  };

  let dataObj = chartData;

  const chartData1 = {
    labels,
    datasets: [
      {
        label: "Planned Expenses",
        data: dataObj.map((d) => +d.plannedExpenses),
        borderColor: "#4cc9f0",
        backgroundColor: "#4cc9f0",
        tension: 0,
      },
      {
        label: "Income from Brokerage Accounts",
        data: dataObj.map((d) => +d.brokerageIncome),
        borderColor: "#301934",
        backgroundColor: "#301934",
        tension: 0,
      },
      {
        label: "Property Income",
        data: dataObj.map((d) => +d.propertyIncome),
        borderColor: "#f72585",
        backgroundColor: "#f72585",
        tension: 0,
      },
      {
        label: "Income from Other Sources",
        data: dataObj.map((d) => +d.otherIncome),
        borderColor: "#8725f7",
        backgroundColor: "#8725f7",
        tension: 0,
      },

      {
        label: "Depletion",
        data: dataObj.map((d) => +d.depletion),
        borderColor: "#00008B",
        backgroundColor: "#00008B",
        tension: 0,
      },
      {
        label: "Surplus",
        data: dataObj.map((d) => +d.surplus),
        borderColor: "#008c2cff",
        backgroundColor: "#008c2cff",
        tension: 0,
      },

      // lifeEventsDataset
      /*{
         label: "Planned Expenses",
         data: dataPoints,
         fill: false,
         borderColor: "blue",
         tension: 0.3,
         // Point styling
         pointBackgroundColor: "red",
         pointRadius: 6,
       },*/
    ],
  };




  useEffect(() => {
    if (!chartRef.current) return;

    /* const chart = chartRef.current;
   
       const yScale = chart.scales.y; // main y-axis
   
       const PIXEL_OFFSET = 60; // pixels above X-axis
   
       const newScatterData = depletions
         .map((event) => {
           const year = getYear(event.plannedDate);
           if (!labels.includes(year)) return null;
   
           // Calculate Y value that is 10px above X-axis
           const yPixel = yScale.getPixelForValue(yScale.min) - PIXEL_OFFSET;
           const yValue = yScale.getValueForPixel(yPixel);
   
           return {
             x: year,
             y: yValue,
             name: event.eventname,
             plannedExpense: Number(event.plannedExpense),
           };
         })
         .filter(Boolean);
   
       setScatterData(newScatterData);*/
  }, [chartData1, lifeEvents]);


  //  const data = { labels: label, chartData };

  const options = {
    responsive: true,
    plugins: {
      legend: {

      },


      datalabels: {
        display: true,
        color: "green",
        align: "top",
        anchor: "end",
        font: { weight: "bold" },
        formatter: (value, context) => {

          return null; // don't show labels for line datasets
        },
      },
      tooltip: {
        backgroundColor: "#ffffff",
        titleColor: "#000",
        bodyColor: "#000",
        borderColor: "#e5e7eb",
        borderWidth: 1,
        bodySpacing: 6, // space between body lines
        titleSpacing: 8, // space between title & body
        padding: 12,
        callbacks: {
          label: (ctx) => {
            if (ctx.dataset.type === "scatter") {
              const e = ctx.raw;
              return [
                `Event : ${e.name}`,
                `Expense :$${e.plannedExpense.toLocaleString()}`,
                `Year :${e.x}`,
              ];
            }
            if (ctx.dataset.label === "Income from Other Sources") {
              const data = normalizedReportData[ctx.dataIndex];
              const breakup = data.incomeBreakup || {};
              const excluded = ["Property", "Brokerage Accounts"];

              const otherEntries = Object.entries(breakup).filter(
                ([key]) => !excluded.includes(key)
              );

              return [
                ...otherEntries.map(
                  ([key, val]) => `${key}: $${FormatAmount(val).toLocaleString()}`
                ),
              ];
            }
            return `${ctx.dataset.label}: $${FormatAmount(ctx.raw).toLocaleString()}`;
          },
        },
      },
    },

    scales: {
      x: { title: { display: true, text: "Year" } },
      y: {
        beginAtZero: true,
        title: { display: true, text: "Projected Value" },
        ticks: {
          callback: (v) => `$${Number(v).toLocaleString()}`,
        },
      },
    },
  };

  return (
    <>

      <div className="NetWorth">
        <div className="flex">
          <div className="bannerStyle col-12 mb-4 mt-2">Income Projection</div>
        </div>
        <Line ref={chartRef} data={chartData1} options={options} />
      </div>
    </>
  );
};
export default LineChartIncome;
